import * as ACTION_TYPES from '@actions/action_types'

export interface OrderReducerInterface {
  ids?: string[]
  download_toggle: boolean
  queryString?: object
  tab?: string
  modal_action?: string
}

export const initialState: OrderReducerInterface = {
  ids: [],
  download_toggle: false,
  queryString: {},
  tab: '',
  modal_action: '',
}

const OrderReducer = (state: OrderReducerInterface, action: A) => {
  switch (action.type) {
    case ACTION_TYPES.DOWNLOAD_TOGGLE:
      return {
        ...state,
        download_toggle: action.download_toggle,
      }
    case ACTION_TYPES.DOWNLOAD_MULTIPLE:
      // console.log(action.ids)
      return {
        ...state,
        ids: action.ids,
      }
    case ACTION_TYPES.ORDER_SET_QUERY_STRING:
      return { ...state, queryString: action.queryString }
    case ACTION_TYPES.CHANGE_TAB:
      return { ...state, tab: action.tab }
    default:
      return state
  }
}
export default OrderReducer
